import src from "IMAGE";
export default { src, width: 861, height: 255, blurWidth: 0, blurHeight: 0};
